// @ts-ignore
import styles from './styles.module.css';
import Container from '../../components/MainContainerWithWindow/Container';
import { Button } from '../../components/Button/Button';
import { ControlledInput } from '../../components/ControlledInput/ControlledInput';
import { Selector } from '../../components/Selector/Selector';
import { useGetCurrencyQuery } from '../../redux/services/CurrencyApi';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import React, { useState } from 'react';
import { useCreateWithdrawalMutation } from '../../redux/services/MerchantApi';
import { pushNotify } from '../../components/Notifications';
import Modal from '../../components/ModalDefault/Modal';
import { SuccessTransfer } from '../Merchant/TransferStatus/components/SuccessTransfer/SuccessTransfer';

type WithdrawalInputs = {
  currency_code_from: string;
  currency_code_to: string;
  amount: string;
  requisite_type: string;
  bank?: string;
  requisite_number: string;
  account_owner?: string;
};

const Withdrawal = () => {
  const [createWithdrawal] = useCreateWithdrawalMutation();
  const { data: currencyList = [] } = useGetCurrencyQuery();
  const [modalActive, setModalActive] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState<string>('SBP');
  const formMethods = useForm<WithdrawalInputs>({
    defaultValues: { bank: undefined, account_owner: undefined },
  });
  const { handleSubmit, resetField } = formMethods;

  const onSubmit = (data: WithdrawalInputs) => {
    if (Number(data.amount) <= 0) {
      pushNotify('Сумма для вывода должна быть больше 0', 'Error');
      return;
    }

    createWithdrawal({
      ...data,
      requisite_type: selectedMethod,
      currency_code_from: 'USDT',
      amount: Number(data.amount.replace(/\s/g, '')),
      bank: selectedMethod !== 'IBAN' ? data.bank : undefined,
    });

    setModalActive(true);
    resetField('account_owner');
    resetField('bank');
  };

  return (
    <FormProvider {...formMethods}>
      <Container>
        <div className={styles.wrapper}>
          <h1>Введите сумму вывода</h1>
          <p>
            <img src={'/error_icon.png'} alt={'error icon'} />
            Вы выводите деньги на свой банковский счет через систему переводов
          </p>
          <div className={styles.limits}>Лимиты для пополнения в RUB: от 500 до 300 000</div>

          <div className={styles.formContainer}>
            <ControlledInput
              title={'Сумма для перевода'}
              blockStyle={{ width: '362px' }}
              placeholder={'Введите сумму'}
              rules={{ required: true }}
              name={'amount'}
              type={'text'}
              errorText={'Сумма не попадает в установленный лимит'}
              transform={(text: string | undefined) => {
                if (text) {
                  return text.replace(/[^0-9]/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                }
                return text;
              }}
            />
            <Selector
              blockStyle={{ width: '100%', flex: '1' }}
              title={'Валюта'}
              defaultValue={currencyList.filter((item) => item.name === 'RUB')[0]?.name || ''}
              placeholder={''}
              name={'currency_code_to'}
              items={currencyList.filter((item) => item.name === 'RUB')}
            />
          </div>

          <div>
            {selectedMethod === 'IBAN' && (
              <React.Fragment>
                <ControlledInput
                  title={'Номер реквизита'}
                  placeholder={'Номер реквизита'}
                  rules={{ required: true }}
                  name={'requisite_number'}
                  type={'text'}
                />
                <ControlledInput
                  title={'Владелец счета'}
                  placeholder={'Владелец счета'}
                  rules={{ required: true }}
                  name={'account_owner'}
                  type={'text'}
                />
              </React.Fragment>
            )}
            {selectedMethod === 'C2C' && (
              <div style={{ display: 'flex', gap: '8px' }}>
                <ControlledInput
                  title={'Номер карты'}
                  blockStyle={{ flex: '1' }}
                  placeholder={'Номер карты'}
                  rules={{ required: selectedMethod === 'C2C', maxLength: 19, minLength: 19 }}
                  transform={(text: string | undefined) => {
                    if (text) {
                      return text
                        .replace(/\D/g, '')
                        .replace(/(\d{4})/g, '$1 ')
                        .trim()
                        .slice(0, 19);
                    }
                    return text;
                  }}
                  name={'requisite_number'}
                  type={'text'}
                />
                <ControlledInput
                  title={'Банк'}
                  blockStyle={{ flex: '1' }}
                  placeholder={'Банк'}
                  rules={{ required: true }}
                  name={'bank'}
                  type={'text'}
                />
              </div>
            )}
            {selectedMethod === 'SBP' && (
              <div style={{ display: 'flex', gap: '8px' }}>
                <Controller
                  rules={{
                    required: selectedMethod === 'SBP',
                    minLength: 12,
                    maxLength: 12,
                  }}
                  render={({ field: { onChange, ref, value } }) => (
                    <div style={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
                      <label style={{ fontSize: '14px' }}>
                        {selectedMethod === 'SBP' && <span style={{ color: 'red' }}>*</span>} Номер
                        телефона
                      </label>
                      <input
                        type='text'
                        onChange={(e) => {
                          if (Number.isNaN(+e.target.value) || e.target.value.slice(-1) === ' ') {
                            return;
                          }
                          if (e.target.value.startsWith('+7')) {
                            onChange(e.target.value);
                          }
                        }}
                        onFocus={(e) => {
                          if (e.target.value === '') {
                            onChange('+7');
                          }
                        }}
                        onBlur={(e) => {
                          if (e.target.value === '+7') {
                            onChange('');
                          }
                        }}
                        ref={ref}
                        value={value}
                        maxLength={12}
                        minLength={12}
                        className={styles.myInput}
                        placeholder={'Номер телефона'}
                        disabled={selectedMethod !== 'SBP'}
                        style={{
                          fontSize: '14px',
                          border: '2px solid #dbe0f2',
                          padding: '10px 12px',
                          borderRadius: '4px',
                          outline: 'none',
                        }}
                      />
                    </div>
                  )}
                  name={'requisite_number'}
                />
                <ControlledInput
                  title={'Банк'}
                  blockStyle={{ flex: '1' }}
                  placeholder={'Банк'}
                  rules={{ required: true }}
                  name={'bank'}
                  type={'text'}
                />
              </div>
            )}
            {selectedMethod === 'TRANSFER' && (
              <div style={{ display: 'flex', gap: '8px' }}>
                <ControlledInput
                  title={'Номер счета'}
                  blockStyle={{ flex: '1' }}
                  placeholder={'Номер счета'}
                  rules={{
                    required: selectedMethod === 'TRANSFER' && !!selectedMethod,
                    minLength: 20,
                    maxLength: 20,
                  }}
                  transform={(text: string | undefined) => {
                    if (text) {
                      return text.replace(/[^0-9]/g, '');
                    }
                    return text;
                  }}
                  name={'requisite_number'}
                  type={'text'}
                />
                <ControlledInput
                  title={'Банк'}
                  blockStyle={{ flex: '1' }}
                  placeholder={'Банк'}
                  rules={{ required: true }}
                  name={'bank'}
                  type={'text'}
                />
              </div>
            )}
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '20px' }}>
            <h4>Метод оплаты</h4>
            <div style={{ display: 'flex', gap: '32px' }}>
              <label htmlFor='sbp' style={{ display: 'flex', gap: '4px', cursor: 'pointer' }}>
                <input
                  type='radio'
                  name='method'
                  value='SBP'
                  id='sbp'
                  style={{ accentColor: '#1890FF' }}
                  checked={selectedMethod === 'SBP'}
                  onChange={(e) => setSelectedMethod(e.target.value)}
                />
                СБП
              </label>
              <label htmlFor='c2c' style={{ display: 'flex', gap: '4px', cursor: 'pointer' }}>
                <input
                  type='radio'
                  name='method'
                  value='C2C'
                  id='c2c'
                  style={{ accentColor: '#1890FF' }}
                  checked={selectedMethod === 'C2C'}
                  onChange={() => setSelectedMethod('C2C')}
                />
                Банковская карта
              </label>
            </div>
            <div style={{ display: 'flex', gap: '28px' }}>
              <label htmlFor='iban' style={{ display: 'flex', gap: '4px', cursor: 'pointer' }}>
                <input
                  type='radio'
                  name='method'
                  value='IBAN'
                  id='iban'
                  style={{ accentColor: '#1890FF' }}
                  checked={selectedMethod === 'IBAN'}
                  onChange={() => setSelectedMethod('IBAN')}
                />
                IBAN
              </label>
              <label htmlFor='transfer' style={{ display: 'flex', gap: '4px', cursor: 'pointer' }}>
                <input
                  type='radio'
                  name='method'
                  value='TRANSFER'
                  id='transfer'
                  style={{ accentColor: '#1890FF' }}
                  checked={selectedMethod === 'TRANSFER'}
                  onChange={() => setSelectedMethod('TRANSFER')}
                />
                Перевод по номеру счета
              </label>
            </div>
          </div>
          <Button
            text={'Пополнить'}
            type={'submit'}
            style={{
              width: '100%',
              marginTop: '24px',
              background: '#1890FF',
              border: 'auto',
            }}
            action={handleSubmit(onSubmit)}
          />
        </div>
      </Container>
      <Modal
        active={modalActive}
        setActive={setModalActive}
        style={{ textAlign: 'center', padding: '36px' }}
        className={''}
        hasCloseButton={false}
      >
        <div className={styles.modalWrapper}>
          <h1>Спасибо! Заявка успешно создана</h1>
          <Button action={() => setModalActive(false)} text={'Закрыть'} style={{ width: '100%' }} />
        </div>
      </Modal>
    </FormProvider>
  );
};

export default Withdrawal;
